module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('agenda')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f212a50c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inicio.vue
// module id = 303
// module chunks = 1